import { Component, ViewChild, Output, EventEmitter, OnInit, Input } from '@angular/core';
import { SlickGridOptions, SlickGridColumnModel, SlickGridComponent, SlickContextMenuComponent, SlickGridColumnFilterTypes, SlickScreenBlockerService, SlickConfirmDialogComponent, SlickConfirmDialogResults, SlickToastService } from "@slick-components";
import { GlobalsService, AuthService, FunctionLockService, PaymentsService, SleepService } from '@services';
import { HttpHeaders } from '@angular/common/http';
import { IPaymentModel, IPaymentListViewModel, PaymentModel } from '@models';
import * as moment from 'moment';

@Component({
	selector: 'payments-grid',
	templateUrl: './payments-grid.component.html',
	providers: [PaymentsService, SlickScreenBlockerService, SlickToastService]
})
export class PaymentsGridComponent implements OnInit {
	@Input() autoSelectFirstRow: boolean = false;
	@Input() customerId?: number;
	@Input() hideFilters = false;
	@Input() hideNewButton: boolean = false;
	@Output() onPaymentSelected = new EventEmitter<IPaymentModel>();

	@ViewChild('paymentsGrid', { static: true }) paymentsGrid: SlickGridComponent;
	@ViewChild('paymentsGridContextMenuRef', { static: true }) paymentsGridContextMenuRef: SlickContextMenuComponent;
	@ViewChild("deletePaymentConfirmRef", { static: true }) deletePaymentConfirmRef: SlickConfirmDialogComponent;

	gridOptions = new SlickGridOptions();
	selectedPayment: IPaymentModel;

	searchText: string;
	lastSearchString;
	searchTimeout: NodeJS.Timer;
	showUnappliedOnly = ((localStorage.getItem("PAYMENTS_SHOW_UNAPPLIED_ONLY") || 'false') === 'true');
	showArchived = ((localStorage.getItem("PAYMENTS_SHOW_ARCHIVED") || 'false') === 'true');
	isIMPC = (GlobalsService.company.companyId === 1);
	isBambora: boolean = GlobalsService.company.useBambora;
	private contextMenuData: any;

	constructor(
		private authService: AuthService,
		private functionLockService: FunctionLockService,
		private slickScreenBlockerService: SlickScreenBlockerService,
		private slickToastService: SlickToastService,
		private paymentsService: PaymentsService) {
		this.gridOptions.gridKey = 'Payments';
		this.gridOptions.striped = false;
		this.gridOptions.bordered = false;

		if (GlobalsService.isQuickbooksEnabled)
			this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ columnKey: "QUICKBOOKS_SYNC", title: 'QB', dataFieldName: 'quickbooksSyncStatus', default: true }));
		if (GlobalsService.isBusinessCentralEnabled)
			this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ columnKey: "BUSINESS_CENTRAL_SYNC", title: 'BC', dataFieldName: 'businessCentralSyncStatus', default: true }));
		this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Customer', dataFieldName: 'displayName', default: true/*, filterType: SlickGridColumnFilterTypes.text*/ }));
		if (!this.isBambora) 
			this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ columnKey: "IS_VOIDED", title: 'Void', dataFieldName: 'isVoided', default: true/*, filterType: SlickGridColumnFilterTypes.text*/ }));
		
		this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Customer', dataFieldName: 'displayName', default: true/*, filterType: SlickGridColumnFilterTypes.text*/ }));
		this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'First Name', dataFieldName: 'firstName', default: false/*, filterType: SlickGridColumnFilterTypes.text*/ }));
		this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Last Name', dataFieldName: 'lastName', default: false/*, filterType: SlickGridColumnFilterTypes.text*/ }));
		this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Full Name', dataFieldName: 'fullName', default: false/*, filterType: SlickGridColumnFilterTypes.text*/ }));
		this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Company', dataFieldName: 'companyName', default: false/*, filterType: SlickGridColumnFilterTypes.text*/ }));
		this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Address1', dataFieldName: 'address1', default: false/*, filterType: SlickGridColumnFilterTypes.text*/ }));
		this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Address2', dataFieldName: 'address2', default: false/*, filterType: SlickGridColumnFilterTypes.text*/ }));
		this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'City', dataFieldName: 'city', default: false/*, filterType: SlickGridColumnFilterTypes.text*/ }));
		this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'State', dataFieldName: 'state', default: false/*, filterType: SlickGridColumnFilterTypes.text*/ }));
		this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Zipcode', dataFieldName: 'zipcode', default: false/*, filterType: SlickGridColumnFilterTypes.text*/ }));
		this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Country', dataFieldName: 'country', default: false/*, filterType: SlickGridColumnFilterTypes.text*/ }));
		this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Payment Amount', dataFieldName: 'amountDisplay', default: true/*, filterType: SlickGridColumnFilterTypes.text*/ }));
		if(!this.isBambora)
			this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ columnKey: "REFUND", title: 'Amount Refunded', dataFieldName: 'amountRefunded', default: true/*, filterType: SlickGridColumnFilterTypes.text*/ }));
		this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Applied Amount', dataFieldName: 'appliedPaymentAmountDisplay', default: true/*, filterType: SlickGridColumnFilterTypes.text*/ }));
		this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Remaining', dataFieldName: 'totalRemainingAmountDisplay', default: true/*, filterType: SlickGridColumnFilterTypes.text*/ }));
		this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ columnKey: "PAYMENT_DATE", title: 'Payment Date', dataFieldName: 'paymentDate', default: true/*, filterType: SlickGridColumnFilterTypes.text*/ }));
		this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Payment Type', dataFieldName: 'paymentType', default: true/*, filterType: SlickGridColumnFilterTypes.text*/ }));
		this.gridOptions.columns.push(SlickGridColumnModel.addGridColumn({ title: 'Ref #', dataFieldName: 'referenceNumber', default: true/*, filterType: SlickGridColumnFilterTypes.text*/ }));

		this.gridOptions.getUrl = GlobalsService.apiUrl + '/payments/getPaymentsForGridView';
		this.gridOptions.httpHeaders = new HttpHeaders()
			.append('Authorization', `Bearer ${this.authService.getToken()}`)
			.append("TimeZoneOffset", (moment().utcOffset() / 60).toString());
	}

	async ngOnInit() {
		this.gridOptions.autoSelectFirstRow = this.autoSelectFirstRow;
		this.updateGrid();
	}

	private suppressRowSelected = false;

	async onRowClicked(paymentListViewModel: IPaymentListViewModel) {
		if (this.suppressRowSelected) {
			this.suppressRowSelected = false;
			return;
		}
		// already on this row? skip the round-trip
		if (this.selectedPayment?.paymentId === paymentListViewModel.paymentId) return;

		try {
			await this.functionLockService.lock("GET_PAYMENT");
			// The full payment is fetched before anything reacts to the click, so this is the only
			// feedback the user gets until the detail (or the customer page's dialog) appears
			this.slickScreenBlockerService.block();
			this.selectedPayment = await this.paymentsService.getPayment(paymentListViewModel.paymentId);
			this.onPaymentSelected.emit(this.selectedPayment);
		} finally {
			this.slickScreenBlockerService.unblock();
			this.functionLockService.release("GET_PAYMENT");
		}
	}
	async onRowContextMenu(contextMenuData) {
		(<MouseEvent>contextMenuData.mouseEvent).preventDefault();
		this.contextMenuData = contextMenuData;

		this.paymentsGridContextMenuRef.showContextMenu(contextMenuData.mouseEvent);
	}

	async contextMenuDeletePayment() {
		const paymentGridModel: IPaymentListViewModel = this.paymentsGrid.visibleData[this.contextMenuData.rowIdx];
		const confirmResult = await this.deletePaymentConfirmRef.confirm();

		if (confirmResult === SlickConfirmDialogResults.Ok) {
			await this.paymentsService.deletePayment(paymentGridModel.paymentId);

			this.paymentsGrid.visibleData = this.paymentsGrid.visibleData.filter(x => x.paymentId !== paymentGridModel.paymentId);
			if (this.selectedPayment.paymentId === paymentGridModel.paymentId) {
				this.selectedPayment = null;
				this.paymentsGrid.unselectRow();
				this.onPaymentSelected.emit(null);
			}

			this.slickToastService.showSuccess("Payment Deleted", 1000);
		}

	}

	async onSearch(searchText: string) {
		this.searchText = searchText;

		this.updateGrid();
	}

	async onNewPayment() {
		this.selectedPayment = new PaymentModel();
		this.onPaymentSelected.emit(this.selectedPayment);
	}

	async onShowUnappliedOnlyChanged() {
		await SleepService.sleep();

		localStorage.setItem("PAYMENTS_SHOW_UNAPPLIED_ONLY", (this.showUnappliedOnly) ? 'true' : 'false');
		this.updateGrid();
	}

	async onShowArchivedChanged() {
		await SleepService.sleep();

		localStorage.setItem("PAYMENTS_SHOW_ARCHIVED", (this.showArchived) ? 'true' : 'false');
		this.updateGrid();
	}

	async updateGrid() {
		try {
			await this.functionLockService.lock("UPDATE_GRID");
			this.slickScreenBlockerService.block(500);

			const params = {
				searchString: this.searchText,
				showUnappliedOnly: this.showUnappliedOnly,
				showArchived: this.showArchived,
				customerId: this.customerId
			};

			await this.paymentsGrid.reloadGrid(params);
			if (this.autoSelectFirstRow && this.paymentsGrid.getVisibleRecords().length > 0)
				this.paymentsGrid.selectRow(0);
		}
		finally {
			this.slickScreenBlockerService.unblock();
			await this.functionLockService.release("UPDATE_GRID");
		}
	}

	async refreshRow(paymentModel: IPaymentModel) {
		const paymentGridModel = await this.paymentsService.getPaymentListView(paymentModel.paymentId);

		const existingPaymentIdx = this.paymentsGrid.visibleData.findIndex(x => x.paymentId === paymentModel.paymentId);
		if (existingPaymentIdx >= 0)
			this.paymentsGrid.updateRecord(existingPaymentIdx, paymentGridModel);
		else
			this.paymentsGrid.addNewRecord(paymentGridModel);

	}

	findPayment(payment: IPaymentModel) {
		const idx = this.paymentsGrid.visibleData.findIndex(x => x.paymentId === payment.paymentId);
		if (idx >= 0) {
			this.suppressRowSelected = true;
			this.paymentsGrid.selectRow(idx);
		}
		this.selectedPayment = payment;
	}
}
